import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { useDefinedParams } from '@/hooks/useDefinedParams';
import { useJbpQuery, RestTypes } from '@/hooks/useJbpQuery';
import { useBookingPayload } from '@/hooks/useBookingPayload';
import { ApiError } from '@/elements/ApiError';
import { BookingResponse } from '../../../../../APIDocs/apiTypes';
import { BookingSuccess } from './BookingSuccess';
import { BookingResultLoading } from '@/elements/loadingElements/BookingResultLoading';

export const BookingResult = () => {
  // mpan is not being used but if its removed the serviceLine becomes undefined
  const [mpan, serviceLine] = useDefinedParams(['mpan', 'serviceLine']);
  const state = useAppSelector(state => state.jbp);

  const bookingPayload = useBookingPayload();
  const { isLoading, data, refetch } = useJbpQuery<BookingResponse, BookingResponse>(RestTypes.Post, bookingPayload, ['booking'], `jbp/${mpan}/booking`, false, serviceLine);
  const [bookJobRequestMade, setBookingRequestMade] = useState(false);
  const nav = useNavigate();
  const shouldPostBookingRequest: boolean | undefined = state.offer?.offerTokenSelected;

  let backButtonPrevented = false;
  history.pushState(null, document.title, location.href);

  function popStateListener() {
    if (backButtonPrevented === false) {
      history.pushState(null, document.title, location.href);
      backButtonPrevented = true;
      nav(`/site/${mpan}/${serviceLine}`);
    } else {
      window.removeEventListener('popstate', popStateListener);
    }
  }

  window.addEventListener('popstate', popStateListener);

  const triggerBookJob = () => {
    setBookingRequestMade(true);
    refetch();
  };

  if (shouldPostBookingRequest === true && bookJobRequestMade === false) {
    triggerBookJob();
    return <span></span>;
  } else if (shouldPostBookingRequest == null || shouldPostBookingRequest == false) {
    return <ApiError errorDescription={'You have not completed the questions required to confirm your booking. Please return to the site page and follow the book job process '}></ApiError>;
  } else if (isLoading) {
    return <BookingResultLoading />;
  } else {
    if (data?.Status == 'Success' && data?.ConfirmationID != undefined) {
      return (
        <div>
          <BookingSuccess bookingId={data.ConfirmationID} />
        </div>
      );
    } else {
      return (
        <div>
          <ApiError errorDescription={data?.ErrorDescription}></ApiError>
        </div>
      );
    }
  }
};
